import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import Navbar from './Navbar';
import Footer from './Footer';
import Container from './Container';
import Button from './Button';

const ForgotPasswordPage = () => {
  const [formData, setFormData] = useState({
    email: ''
  });
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success'); // 'success' or 'error'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.email) {
      setModalMessage('Παρακαλώ εισάγετε το email σας');
      setModalType('error');
      setShowModal(true);
      return;
    }

    setLoading(true);

    try {
      // Use Supabase's built-in password reset functionality
      const { error } = await supabase.auth.resetPasswordForEmail(formData.email, {
        redirectTo: `${window.location.origin}/reset-password`
      });

      if (error) {
        throw error;
      }

      // Success - show success message
      setModalMessage(`Στάλθηκε email επαναφοράς κωδικού στο ${formData.email}. Παρακαλώ ελέγξτε το email σας και ακολουθήστε τις οδηγίες.`);
      setModalType('success');
      setShowModal(true);
      
      // Reset form
      setFormData({ email: '' });
      
    } catch (error) {
      console.error('Password reset error:', error);
      setModalMessage(`Σφάλμα κατά την αποστολή του email επαναφοράς: ${error.message}`);
      setModalType('error');
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ backgroundColor: '#1A202C', minHeight: '100vh' }}>
      <Navbar />
      
      <main style={{ padding: '5rem 0 6rem 0', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(800px 800px at 10% -10%, rgba(16,185,129,0.15), transparent), radial-gradient(800px 800px at 110% 10%, rgba(59,130,246,0.08), transparent)' }} />
        <Container>
          <div style={{
            maxWidth: '500px',
            margin: '0 auto',
            position: 'relative'
          }}>
            {/* Header */}
            <div style={{ 
              textAlign: 'center', 
              marginBottom: '2rem' 
            }}>
              <h1 style={{
                fontSize: '2.25rem',
                fontWeight: 'bold',
                color: '#f7fafc',
                marginBottom: '0.75rem'
              }}>
                Ξεχάσατε τον κωδικό;
              </h1>
              <p style={{
                fontSize: '1.125rem',
                color: '#a0aec0',
                lineHeight: '1.6'
              }}>
                Εισάγετε το email σας για να σας στείλουμε οδηγίες επαναφοράς κωδικού.
              </p>
            </div>

            {/* Card wrapper */}
            <div style={{ background: 'linear-gradient(135deg, rgba(16,185,129,0.35), rgba(59,130,246,0.25))', borderRadius: '1rem', padding: '1px' }}>
              <div style={{ backgroundColor: '#2d3748', borderRadius: '1rem', padding: '2rem' }}>
                {/* Forgot Password Form */}
                <form onSubmit={handleSubmit} style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1.5rem'
                }}>
                  {/* Email Field */}
                  <div>
                    <label style={{
                      display: 'block',
                      color: '#f7fafc',
                      fontSize: '1rem',
                      fontWeight: '500',
                      marginBottom: '0.5rem'
                    }}>
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Εισάγετε το email σας"
                      required
                      disabled={loading}
                      style={{
                        width: '100%',
                        padding: '0.875rem 1rem',
                        backgroundColor: '#2d3748',
                        border: '1px solid #4a5568',
                        borderRadius: '0.5rem',
                        color: '#f7fafc',
                        fontSize: '1rem',
                        transition: 'border-color 0.2s, box-shadow 0.2s',
                        opacity: loading ? 0.6 : 1
                      }}
                      onFocus={(e) => {
                        if (!loading) {
                          e.target.style.borderColor = '#10B981';
                          e.target.style.boxShadow = '0 0 0 3px rgba(16, 185, 129, 0.1)';
                        }
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#4a5568';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>

                  {/* Send Request Button */}
                  <div style={{ marginTop: '0.5rem' }}>
                    <Button
                      type="submit"
                      variant="primary"
                      size="lg"
                      style={{ width: '100%' }}
                      disabled={loading}
                    >
                      {loading ? 'Αποστολή...' : 'Στείλτε Αίτηση'}
                    </Button>
                  </div>

                  {/* Back to Login Link */}
                  <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                    <Link
                      to="/login"
                      style={{
                        color: '#10B981',
                        fontSize: '0.95rem',
                        textDecoration: 'underline',
                        transition: 'color 0.2s'
                      }}
                      onMouseEnter={(e) => e.target.style.color = '#0d9488'}
                      onMouseLeave={(e) => e.target.style.color = '#10B981'}
                    >
                      ← Επιστροφή στη Σύνδεση
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Container>
      </main>
      
      <Footer />

      {/* Success/Error Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md" style={{ 
            backgroundColor: '#2D3748', 
            borderColor: '#4A5568' 
          }}>
            <div className="mt-3">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-medium text-white">
                  {modalType === 'success' ? 'Επιτυχία' : 'Σφάλμα'}
                </h3>
                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-400 hover:text-gray-300"
                >
                  <span className="sr-only">Κλείσιμο</span>
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              
              <div className="mb-6">
                <div className="text-sm text-gray-300 whitespace-pre-line">
                  {modalMessage}
                </div>
              </div>
              
              <div className="flex justify-end">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors"
                  style={{ backgroundColor: '#10B981' }}
                >
                  Εντάξει
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgotPasswordPage; 